(() => {
  if (window.__estimateDeliveryInit) return;
  window.__estimateDeliveryInit = true;

  const COUNTRY_RANGES = {
    AU: { min: 15, max: 22 },
    CA: { min: 15, max: 25 },
    DK: { min: 12, max: 20 },
    DE: { min: 10, max: 15 },
    NL: { min: 8, max: 10 },
    NZ: { min: 14, max: 20 },
    NO: { min: 12, max: 20 },
    SE: { min: 12, max: 20 },
    GB: { min: 7, max: 12 },
    US: { min: 5, max: 9 }
  };

  const CURRENCY_FALLBACK = {
    AUD: COUNTRY_RANGES.AU,
    CAD: COUNTRY_RANGES.CA,
    DKK: COUNTRY_RANGES.DK,
    EUR: COUNTRY_RANGES.DE,
    NZD: COUNTRY_RANGES.NZ,
    NOK: COUNTRY_RANGES.NO,
    SEK: COUNTRY_RANGES.SE,
    GBP: COUNTRY_RANGES.GB,
    USD: COUNTRY_RANGES.US
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    }).format(date);

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const updateAll = (minDays, maxDays) => {
    const nodes = document.querySelectorAll('[data-estimate-delivery]');
    nodes.forEach((node) => {
      const min = typeof minDays === 'number' && Number.isFinite(minDays) ? minDays : 8;
      const max = typeof maxDays === 'number' && Number.isFinite(maxDays) ? maxDays : 17;
      const minDate = addDays(new Date(), min);
      const maxDate = addDays(new Date(), max);
      const dateEl = node.querySelector('.estimate-delivery__date');
      if (dateEl) {
        dateEl.innerHTML = `<span class="estimate-delivery__label-text">FREE delivery: </span><span class="estimate-delivery__dates">${formatDate(minDate)} \u2013 ${formatDate(maxDate)}</span>`;
      }
    });
  };

  const applyCountryRange = (countryCode) => {
    if (!countryCode) return;
    const range = COUNTRY_RANGES[countryCode.toUpperCase()];
    if (range) {
      updateAll(range.min, range.max);
    }
  };

  const applyCurrencyRange = (currencyCode) => {
    if (!currencyCode) return;
    const range = CURRENCY_FALLBACK[currencyCode.toUpperCase()];
    if (range) {
      updateAll(range.min, range.max);
    }
  };

  const getHeaderCurrency = () => {
    const headerEl =
      document.querySelector('.header__localization .localization-form__select > span') ||
      document.querySelector('.header__localization .disclosure__button > span') ||
      document.querySelector('.header__localization');
    if (!headerEl) return null;
    const text = headerEl.textContent || '';
    const match = text.trim().match(/\b[A-Z]{3}\b/);
    return match ? match[0] : null;
  };

  const applyFromSignals = () => {
    const firstNode = document.querySelector('[data-estimate-delivery]');
    const nodeCountry = firstNode?.dataset?.country;
    const nodeCurrency = firstNode?.dataset?.currency;
    const headerCurrency = getHeaderCurrency();

    if (nodeCountry) {
      applyCountryRange(nodeCountry);
      return true;
    }
    if (nodeCurrency) {
      applyCurrencyRange(nodeCurrency);
      return true;
    }
    if (headerCurrency) {
      applyCurrencyRange(headerCurrency);
      return true;
    }
    return false;
  };

  const runAll = () => {
    updateAll(8, 17);
    if (!applyFromSignals()) {
      applyFromLocalizationJson();
    }
  };

  const applyFromLocalizationJson = () =>
    fetch('/localization.json', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((data) => {
        if (data?.country?.iso_code) {
          document.querySelectorAll('[data-estimate-delivery]').forEach((node) => {
            node.dataset.country = data.country.iso_code;
          });
          applyCountryRange(data.country.iso_code);
          return true;
        }
        if (data?.currency?.iso_code) {
          document.querySelectorAll('[data-estimate-delivery]').forEach((node) => {
            node.dataset.currency = data.currency.iso_code;
          });
          applyCurrencyRange(data.currency.iso_code);
          return true;
        }
        return false;
      })
      .catch(() => false);

  // Default first, then country signals override — order matters
  updateAll(8, 17);
  const initialApplied = applyFromSignals();
  if (!initialApplied) {
    applyFromLocalizationJson().then((applied) => {
      if (applied) return;
      fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((data) => {
          const countryCode = data?.detected_values?.country?.iso_code;
          if (countryCode) {
            applyCountryRange(countryCode);
          }
        })
        .catch(() => {
          /* fallback to default range */
        });
    });
  }

  // Re-run after Shopify section re-renders (variant swap, etc.)
  document.addEventListener('shopify:section:load', runAll);
  document.addEventListener('variant:change', runAll);

  document.addEventListener('click', (event) => {
    const option = event.target.closest('localization-form a[data-value]');
    if (!option) return;
    const countryCode = option.dataset.value;
    if (countryCode) {
      document.querySelectorAll('[data-estimate-delivery]').forEach((node) => {
        node.dataset.country = countryCode;
      });
      applyCountryRange(countryCode);
      return;
    }
    const currency = getHeaderCurrency();
    if (currency) {
      applyCurrencyRange(currency);
    }
  });

  const headerObserverTarget = document.querySelector('.header__localization');
  if (headerObserverTarget) {
    const observer = new MutationObserver(() => {
      applyFromSignals();
    });
    observer.observe(headerObserverTarget, { childList: true, subtree: true, characterData: true });
  }
})();
